<template>
  <div class="search-input">
    <input
      class="search-input__input"
      type="text"
      placeholder="Rechercher: EAN,
    produits, marques, etc."
      @change="$emit('change', $event.target.value)"
    />
    <SearchLogo class="search-input__search-icon" />
  </div>
</template>

<script>
import SearchLogo from "@/assets/svg/search.svg"
export default {
  components: {
    SearchLogo
  }
}
</script>

<style scoped rel="stylesheet/scss" lang="scss">
.search-input {
  background-color: #fff;
  border-bottom: 1px solid #ddd;
  width: 100%;
  padding: 2px;
  padding-right: 20px;
  position: relative;
  overflow: hidden;
  &__input {
    width: 100%;
    border: none;
    padding: 6px 6px 6px 0;
    outline: none;
  }
  &__search-icon {
    height: 26px;
    width: 26px;
    right: 2px;
    top: 3px;
    position: absolute;
    path {
      fill: rgb(164, 165, 166);
    }
  }
}
</style>
